import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const esgHighlightsData = {
    "Environment": [
        {
            id: 1,
            value: "1,265 Metric tonnes of CO2e",
            label: "Scope 1 emissions"
        },
        {
            id: 2,
            value: "6,344 Metric tonnes of CO2e",
            label: "Scope 2 emissions"
        },
        {
            id: 3,
            value: "29,836 Metric tonnes of CO2e",
            label: "Scope 3 emissions"
        },
        {
            id: 4,
            value: "55 Metric tonnes",
            label: "Waste recycled Data as of FY25"
        }
    ],
    "Social": [
        {
            id: 5,
            value: "45%",
            label: "Diversity in leadership roles"
        },
        {
            id: 6,
            value: "10,000+ Hours",
            label: "Employee volunteering and training"
        }
    ],
    "Governance": [
        {
            id: 7,
            value: "100%",
            label: "Compliance on data privacy policies"
        },
        {
            id: 8,
            value: "Tier-1",
            label: "Risk management framework alignment"
        }
    ]
};

const EsgHighlights = () => {
    const [activeTab, setActiveTab] = useState("Environment");

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.1 },
        },
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
    };

    return (
        <section className="w-full bg-white pb-12 sm:pb-16 md:pb-20 lg:pb-24 text-left relative z-10 overflow-hidden">
            <div className="max-w-[1440px] mx-auto w-full px-5 sm:px-10 lg:px-[80px]">

                <div className="w-full mb-6 sm:mb-8">
                    <h2 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] leading-tight tracking-tight">
                        ESG highlights
                    </h2>
                </div>

                <div className="w-full pb-[46px] overflow-x-auto scrollbar-hide flex">
                    <div className="flex gap-6 sm:gap-8 md:gap-10 pb-[1px] shrink-0">
                        {Object.keys(esgHighlightsData).map((tab) => {
                            const isActive = activeTab === tab;
                            return (
                                <button
                                    key={tab}
                                    onClick={() => setActiveTab(tab)}
                                    className={`relative pb-3 text-[14px] sm:text-[16px] font-[500] font-graphik tracking-wide cursor-pointer transition-colors duration-300 border-none outline-none bg-transparent shrink-0 ${isActive ? "text-[#ED6800]" : "text-[#01386A] hover:text-[#ED6800]"
                                        }`}
                                >
                                    {tab}
                                    {isActive && (
                                        <motion.div
                                            layoutId="esgTabLine"
                                            className="absolute bottom-0 left-0 right-0 h-[6px] rounded-full bg-[#ED6800]"
                                            transition={{ type: "spring", stiffness: 380, damping: 30 }}
                                        />
                                    )}
                                </button>
                            );
                        })}
                    </div>
                </div>

                <div className="w-full min-h-[240px]">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={activeTab}
                            variants={containerVariants}
                            initial="hidden"
                            animate="visible"
                            exit="hidden"
                            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 lg:gap-[20px] gap-[16px] w-full items-stretch"
                        >
                            {esgHighlightsData[activeTab].map((item) => (
                                <motion.div
                                    key={item.id}
                                    variants={cardVariants}
                                    whileHover={{ y: -4, transition: { duration: 0.3 } }}
                                    className="group relative p-6 sm:p-8 flex flex-col justify-between transition-all duration-300 hover:shadow-xl w-full min-h-[200px] sm:min-h-[220px] shrink-0 overflow-hidden bg-white border border-[#01386A45] hover:bg-[#0A3966] hover:border-[#0A3966]"
                                >
                                    <div className="w-full flex flex-col gap-4">
                                        <h3 className="text-[16px] sm:text-[20px] font-[600] font-sora leading-tight tracking-tight break-words text-[#01386A] group-hover:text-white transition-colors duration-300">
                                            {item.value}
                                        </h3>
                                    </div>

                                    <div className="w-full mt-auto">
                                        <p className="text-[14px] sm:text-[16px] font-[500] font-graphik leading-relaxed break-words text-[#49577A] group-hover:text-slate-200 transition-colors duration-300">
                                            {item.label}
                                        </p>
                                    </div>
                                </motion.div>
                            ))}
                        </motion.div>
                    </AnimatePresence>
                </div>

            </div>
        </section>
    );
};

export default EsgHighlights;